<template>
  <div>
    <div class="video-container">
        <div v-for="video in videos" class="video" :data-video-id="video.id" @click="playVideo(video.id)">
            <img :src="'https://img.youtube.com/vi/' + video.id + '/0.jpg'">
            <div class="video-title">{{video.title}}<br>{{video.date.format("DD. MMMM YYYY")}}</div>
        </div>
    </div>
    <div class="quote-container" v-if="$t('accordion.audience')">
      <div class="quote-column">
        <div v-for="(quote, index) in quotes">
          <div class="quote" v-if="index % 2 == 0">{{quote}}</div>
        </div>
      </div>
      <div class="quote-column">
        <div v-for="(quote, index) in quotes">
          <div class="quote" v-if="(index + 1) % 2 == 0">{{quote}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import quotes from "../Content/Quotes";

export default {
  name: "group-audience-videos",
  props: ["playVideo"],
  data: function() {
    return {
      quotes: quotes,
      videos: [
        {
          id: "T0uQ7OZ1YJ4",
          title: "Amstetten",
          date: moment("2018-03-27")
        },
        {
          id: "oesyWRqPPRA",
          title: "Ramsau am Dachstein",
          date: moment("2018-03-26")
        },
        {
          id: "vjwQHfGowas",
          title: "Bad Hersfeld",
          date: moment("2018-03-24")
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.quote-container {
  margin-top: 32px;
  display: flex;
  flex-direction: row;

  @include media-phone {
    display: block;
  }

  .quote-column {
    display: flex;
    flex-direction: column;
    min-width: 50%;
    padding: 16px;

    &:nth-child(2) {
      @include media-phone {
        margin-top: 0;
      }
    }

    .quote {
      font-size: 16px;
      padding-bottom: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupAudienceVideos.vue